import * as $          from 'jquery';
import {$body} from "Core/Body";

export const EdroneDynamicEvents = (() => {

    const EdroneEventList  = {
        ADD_TO_CART :   'add_to_cart',
        SUBSCRIBE :     'subscribe'
    };

    const Selector = {
        NEWSLETTER_FORM :       '#newsletter-form',
        NEWSLETTER_EMAIL :      '#email',
        ADD_TO_CART :           '.js_edrone_add_to_cart'
    };

    /**
     * Edrone JS add to cart event
     *
     * @param e
     */
    function edroneEventAddToCart(e)
    {
        // @ts-ignore
        window._edrone = window._edrone || {};
        let btn = $(e.target);

        // @ts-ignore
        if(window._edrone !== undefined){
            // @ts-ignore
            _edrone.product_ids =  btn.data('edrone-product-ids');
            // @ts-ignore
            _edrone.product_skus = btn.data('edrone-product-ids');
            // @ts-ignore
            _edrone.product_titles = btn.data('product-name');
            // @ts-ignore
            _edrone.product_images = btn.data('edrone-product-images');
            // @ts-ignore
            _edrone.product_urls = btn.data('edrone-product-urls');
            // @ts-ignore
            _edrone.product_category_ids = btn.data('edrone-category-ids');
            // @ts-ignore
            _edrone.product_category_names = btn.data('edrone-category-names');
            // @ts-ignore
            _edrone.action_type = EdroneEventList.ADD_TO_CART;
            // @ts-ignore
            _edrone.init()
        }
    }

    /**
     * Edrone JS subscribe event
     *
     * @param e
     * @param email - from Newsletter component, passed by trigger
     */
    function edroneEventSubscribe(e, email)
    {
        if(email !== undefined){
            // @ts-ignore
            window._edrone = window._edrone || {};
            // @ts-ignore
            if(window._edrone !== undefined){
                // @ts-ignore
                _edrone.email = email;
                // @ts-ignore
                _edrone.action_type = EdroneEventList.SUBSCRIBE;
                // @ts-ignore
                _edrone.init()
            }
        }
    }

    $body.on("click", Selector.ADD_TO_CART, edroneEventAddToCart);
    $body.on("eventEdroneSaveToNewsletter", Selector.NEWSLETTER_FORM, edroneEventSubscribe);

    return true;
})();
import * as $          from 'jquery';
import {$body} from "Core/Body";

export const EdroneDynamicEvents = (() => {

    const EdroneEventList  = {
        ADD_TO_CART :   'add_to_cart',
        SUBSCRIBE :     'subscribe'
    };

    const Selector = {
        NEWSLETTER_FORM :       '#newsletter-form',
        NEWSLETTER_EMAIL :      '#email',
        ADD_TO_CART :           '.js_edrone_add_to_cart'
    };

    /**
     * Edrone JS add to cart event
     *
     * @param e
     */
    function edroneEventAddToCart(e)
    {
        // @ts-ignore
        window._edrone = window._edrone || {};
        let btn = $(e.target);

        // @ts-ignore
        if(window._edrone !== undefined){
            // @ts-ignore
            _edrone.product_ids =  btn.data('edrone-product-ids');
            // @ts-ignore
            _edrone.product_skus = btn.data('edrone-product-ids');
            // @ts-ignore
            _edrone.product_titles = btn.data('product-name');
            // @ts-ignore
            _edrone.product_images = btn.data('edrone-product-images');
            // @ts-ignore
            _edrone.product_urls = btn.data('edrone-product-urls');
            // @ts-ignore
            _edrone.product_category_ids = btn.data('edrone-category-ids');
            // @ts-ignore
            _edrone.product_category_names = btn.data('edrone-category-names');
            // @ts-ignore
            _edrone.action_type = EdroneEventList.ADD_TO_CART;
            // @ts-ignore
            _edrone.init()
        }
    }

    /**
     * Edrone JS subscribe event
     *
     * @param e
     * @param email - from Newsletter component, passed by trigger
     */
    function edroneEventSubscribe(e, email)
    {
        if(email !== undefined){
            // @ts-ignore
            window._edrone = window._edrone || {};
            // @ts-ignore
            if(window._edrone !== undefined){
                // @ts-ignore
                _edrone.email = email;
                // @ts-ignore
                _edrone.action_type = EdroneEventList.SUBSCRIBE;
                // @ts-ignore
                _edrone.init()
            }
        }
    }

    $body.on("click", Selector.ADD_TO_CART, edroneEventAddToCart);
    $body.on("eventEdroneSaveToNewsletter", Selector.NEWSLETTER_FORM, edroneEventSubscribe);

    return true;
})();
